<template>
  <div>
    <v-toolbar dense>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="backtolist">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <span>Back</span>
      </v-tooltip>
      <v-toolbar-title class="body-2">Add Bot Template</v-toolbar-title>
    </v-toolbar>
    <v-stepper v-model="stepperModel" vertical>
      <v-stepper-step :complete="stepperModel > 1" step="1">
        Add new Bot in Agent
        <small>Select the Agent</small>
      </v-stepper-step>
      <v-stepper-content step="1">
        <v-layout row wrap class="beez-padding">
          <v-flex xs12>
            <pickable-list-view
              :allItems="allHives"
              :title="title"
              :selectedItem="selectedHive"
              @change="hiveClicked"
              :search-attributes="searchAttributes"
            >
              <template slot="list-item" slot-scope="props">
                <v-hover>
                  <v-list-tile-content slot-scope="{ hover }">
                    <v-container fuild>
                      <v-layout row>
                        <v-flex shrink>
                          <v-list-tile-avatar>
                            <vue-letter-avatar
                              :name="props.item.name"
                              size="40"
                              :rounded="true"
                            />
                          </v-list-tile-avatar>
                        </v-flex>
                        <v-flex grow>
                          <v-list-tile-title v-text="props.item.name" />
                          <v-list-tile-sub-title
                            v-html="props.item.description"
                          />
                        </v-flex>
                        <v-flex shrink>
                          <v-tooltip bottom>
                            <v-btn
                              v-if="hover"
                              slot="activator"
                              icon
                              flat
                              small
                              :to="{
                                name: 'hive-detail',
                                params: { hexId: props.item.hexId }
                              }"
                            >
                              <v-icon>link</v-icon>
                            </v-btn>
                            <span>Quick Link</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-list-tile-content>
                </v-hover>
              </template>
            </pickable-list-view>
          </v-flex>
        </v-layout>
        <v-btn
          :class="!$vuetify.dark ? 'secondary' : ''"
          :outline="$vuetify.dark"
          :color="$vuetify.dark ? 'secondary' : ''"
          class="text-capitalize"
          :disabled="!this.selectedHive"
          @click="stepperModel = 2"
          >Continue
        </v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepperModel > 2" step="2"
        >Name and Description of Bot
        <small>Please enter with the name and description of the bot</small>
      </v-stepper-step>

      <v-stepper-content step="2">
        <v-layout row wrap class="beez-padding">
          <v-flex xs12>
            <v-text-field
              autofocus
              color="secondary"
              v-model="templateName"
              outline
              clearable
              label="Name of the Bot"
              type="text"
            >
              <template v-slot:prepend>
                <v-tooltip bottom>
                  <template>
                    <v-icon slot="activator ">help_outline</v-icon>
                  </template>
                  The Hive loads the Bot based on the Class name
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              color="secondary"
              v-model="templateDescription"
              outline
              clearable
              label="Description of the Bot"
              type="text"
            >
              <template v-slot:prepend>
                <v-tooltip bottom>
                  <template>
                    <v-icon slot="activator ">help_outline</v-icon>
                  </template>
                  The Hive loads the Bot based on the Class name
                </v-tooltip>
              </template>
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-btn
          class="text-capitalize"
          :outline="$vuetify.dark"
          @click="stepperModel = 1"
          >Back
        </v-btn>
        <v-btn
          class="text-capitalize"
          :class="!$vuetify.dark ? 'secondary' : ''"
          :color="$vuetify.dark ? 'secondary' : ''"
          :outline="$vuetify.dark"
          :disabled="!templateName || !templateDescription"
          @click="stepperModel = 3"
        >
          Continue
        </v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepperModel > 3" step="3"
        >Class name of the Bot
        <small>Please enter with the complete namespace</small>
      </v-stepper-step>

      <v-stepper-content step="3">
        <v-layout row wrap class="beez-padding">
          <v-flex xs12>
            <v-text-field
              color="secondary"
              v-model="botClassName"
              outline
              clearable
              label="Class name of the Bot"
              type="text"
            >
              <template v-slot:prepend>
                <v-tooltip bottom>
                  <template>
                    <v-icon slot="activator ">help_outline</v-icon>
                  </template>
                  The Hive loads the Bot based on the Class name
                </v-tooltip>
              </template>
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-btn
          :outline="$vuetify.dark"
          class="text-capitalize"
          @click="stepperModel = 2"
          >Back
        </v-btn>
        <v-btn
          class="text-capitalize"
          :class="!$vuetify.dark ? 'secondary' : ''"
          :color="$vuetify.dark ? 'secondary' : ''"
          :outline="$vuetify.dark"
          :disabled="!botClassName"
          @click="stepperModel = 4"
        >
          Continue
        </v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepperModel > 4" step="4"
        >Add the Bot binary file (.dll or .jar)
        <small>Please make sure that binary has a public class</small>
      </v-stepper-step>

      <v-stepper-content step="4">
        <template>
          <v-layout row wrap class="beez-padding">
            <v-flex xs12>
              <div class="v-input">
                <v-btn
                  flat
                  class="text-capitalize"
                  color="secondary"
                  @click="$refs.binInput.click()"
                >
                  <v-icon>
                    cloud_upload
                  </v-icon>
                  <span>&nbsp; Upload Bot binary</span>
                </v-btn>
                <input
                  :name="binFileOptions.name"
                  @change="uploadBinFile"
                  v-show="false"
                  ref="binInput"
                  type="file"
                  :accept="binFileOptions.acceptFormats"
                />
              </div>
            </v-flex>
            <v-flex xs12 md6 lg3 v-if="binFile">
              <v-card
                :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
                style="border-radius: 5px"
              >
                <v-toolbar flat>
                  <div>Bot binary</div>
                  <v-spacer></v-spacer>
                  <v-icon>attachment</v-icon>
                </v-toolbar>
                <v-card-title primary-title>
                  <div>
                    <div class="subheading">File name: {{ binFile.name }}</div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div>
                    <div class="text-xs-left body-1">
                      File size (in Bytes): {{ binFile.size }}
                    </div>
                    <div class="text-xs-left caption">
                      Last modified date: {{ binFile.lastModifiedDate }}
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </template>
        <v-btn
          :outline="$vuetify.dark"
          class="text-capitalize"
          @click="stepperModel = 3"
          >Back
        </v-btn>
        <v-btn
          class="text-capitalize"
          :class="!$vuetify.dark ? 'secondary' : ''"
          :color="$vuetify.dark ? 'secondary' : ''"
          :outline="$vuetify.dark"
          :disabled="!binFile"
          @click="stepperModel = 5"
          >Continue
        </v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="stepperModel > 5" step="5"
        >Add Dependencies (Optional)
        <small>Dependencies like .dll, .config, .xml etc</small>
      </v-stepper-step>
      <v-stepper-content step="5">
        <template>
          <v-layout row wrap class="beez-padding">
            <v-flex xs12>
              <div class="v-input">
                <v-btn
                  flat
                  class="text-capitalize"
                  color="secondary"
                  @click="$refs.libsInput.click()"
                >
                  <v-icon>
                    cloud_upload
                  </v-icon>
                  <span>&nbsp; Upload Dependencies</span>
                </v-btn>
                <input
                  v-show="false"
                  :name="libFileOptions.name"
                  @change="uploadLibFile"
                  ref="libsInput"
                  type="file"
                  multiple
                />
              </div>
            </v-flex>
            <v-flex xs12 v-if="libFiles && libFiles.length > 0" class="pa-3">
              <v-layout class="row wrap">
                <v-flex
                  :key="key + 'item'"
                  xs12
                  md6
                  lg3
                  class="pa-2"
                  v-for="(item, key) in libFiles"
                >
                  <v-card
                    :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
                    style="border-radius: 5px"
                  >
                    <v-toolbar flat>
                      <div>Bot dependent - {{ key + 1 }}</div>
                      <v-spacer></v-spacer>
                      <v-icon>attachment</v-icon>
                    </v-toolbar>
                    <v-card-title primary-title>
                      <div>
                        <div class="subheading">File name: {{ item.name }}</div>
                      </div>
                    </v-card-title>
                    <v-card-text>
                      <div>
                        <div class="text-xs-left body-1">
                          File size (in Bytes): {{ item.size }}
                        </div>
                        <div class="text-xs-left caption">
                          Last modified date: {{ item.lastModifiedDate }}
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </template>
        <v-btn
          :outline="$vuetify.dark"
          class="text-capitalize"
          @click="stepperModel = 4"
          >Back
        </v-btn>
        <v-btn
          class="text-capitalize"
          :class="!$vuetify.dark ? 'secondary' : ''"
          :color="$vuetify.dark ? 'secondary' : ''"
          :outline="$vuetify.dark"
          @click="stepperModel = 6"
          >Continue
        </v-btn>
      </v-stepper-content>
      <v-stepper-step :complete="stepperModel > 6" step="6"
        >Set Bot Proposals
        <small>Use the JSON editor to paste and preview the proposal</small>
      </v-stepper-step>
      <v-stepper-content step="6">
        <template>
          <proposal-designer @input="updateProposals" />
          <v-btn
            class="text-capitalize"
            :outline="$vuetify.dark"
            @click="stepperModel = 5"
            >Back
          </v-btn>
          <v-btn
            class="text-capitalize"
            :class="!$vuetify.dark ? 'secondary' : ''"
            :color="$vuetify.dark ? 'secondary' : ''"
            :outline="$vuetify.dark"
            @click="stepperModel = 7"
            >Continue
          </v-btn>
        </template>
      </v-stepper-content>
      <v-stepper-step step="7"
        >Set Bot Constants
        <small>Use the JSON editor to paste the constants</small>
      </v-stepper-step>
      <v-stepper-content step="7">
        <template>
          <v-jsoneditor
            v-model="constants"
            :options="{ mode: 'code' }"
            height="400px"
            :plus="true"
          >
          </v-jsoneditor>
          <v-btn
            class="text-capitalize"
            :outline="$vuetify.dark"
            @click="stepperModel = 6"
            >Back
          </v-btn>
          <v-btn
            class="text-capitalize"
            :class="!$vuetify.dark ? 'secondary' : ''"
            :color="$vuetify.dark ? 'secondary' : ''"
            :outline="$vuetify.dark"
            @click="finish"
            :loading="registerLoader"
            >Finish
          </v-btn>
        </template>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PickableListView from '@/components/common/PickableListView'
import ProposalDesigner from './ProposalDesigner'
import moment from 'moment'

export default {
  name: 'BotCreation',
  data: () => ({
    stepperModel: 1,
    selectedHive: null,
    botClassName: null,
    templateName: null,
    templateDescription: null,
    binFile: null,
    formData: null,
    proposals: null,
    constants: [],
    registerLoader: false,
    libFiles: [],
    title: 'Select Agent',
    searchAttributes: ['name', 'description', 'hexId'],
    binFileOptions: {
      name: 'binInput',
      acceptFormats: '.dll,.jar'
    },
    libFileOptions: {
      name: 'libsInput',
      acceptFormats: '.*'
    }
  }),

  methods: {
    uploadBinFile() {
      this.binFile = this.$refs.binInput.files[0]
      this.formData = new FormData()
      this.formData.append('file', this.binFile)
    },
    uploadLibFile() {
      this.libFiles = this.$refs.libsInput.files
      this.formData.append('libs', this.libFiles)
    },

    hiveClicked(hive) {
      this.selectedHive = hive
    },

    updateProposals(proposals) {
      this.proposals = proposals
    },

    backtolist(hexId) {
      this.$router
        .replace({
          name: 'bot-template-detail',
          params: { hexId: hexId }
        })
        .catch()
    },

    async finish() {
      this.registerLoader = true
      let saveData = {
        file: this.binFile,
        libs: Array.from(this.libFiles),
        className: this.botClassName,
        hiveId: this.selectedHive.hexId,
        templateName: this.templateName,
        templateDescription: this.templateDescription,
        proposals:
          this.proposals === null ? null : JSON.stringify(this.proposals),
        constants:
          this.constants === null ? null : JSON.stringify(this.constants)
      }
      try {
        let savedBotTemplate = await this.$store.dispatch(
          'saveBotTemplate',
          saveData
        )
        this.registerLoader = false
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message:
            'Bot Template saved!, Please proceed with the Bot Onboarding',
          description: `Bot Template ${savedBotTemplate.hexId} has been saved Successfully`,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.$store.dispatch('fetchBotTemplates')
        this.backtolist(savedBotTemplate.hexId)
      } catch (err) {
        this.registerLoader = false
        if (err.response.data.status === 409) {
          this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Bot registration Failed',
            description:
              'Bot already registered with same Class name / binaries',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        } else {
          this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Bot registration Failed',
            description: err.response.data,
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
      }
    }
  },

  computed: {
    ...mapState({
      hives: state => state.hives.hives
    }),
    allHives() {
      return this.hives.filter(
        hive =>
          hive.hiveType === 'RPA' ||
          hive.hiveType === 'API' ||
          hive.hiveType === 'JAVA'
      )
    }
  },

  created() {
    this.$store.dispatch('fetchHives')
  },

  components: {
    PickableListView,
    ProposalDesigner
  }
}
</script>

<style scoped></style>
